import _ from 'underscore';

import { INotification, IContext } from '../types';

/**
 * Seperate data source to fetch notifications from different data sources
 */
export class NotificationDataSource {
  private context: IContext;
  private getNotifications: Function;

  constructor(context: IContext, getNotifications: Function) {
    this.context = context;
    this.getNotifications = getNotifications;
  }

  public async fetchCampaignNotificationStatus(): Promise<INotification[]> {
    let notifications: Promise<INotification[]>[] = this.getNotifications(this.context);

    // Add error fallback code for all the notification promises
    notifications = notifications.map((notificationArrPromise: Promise<INotification[]>) => {
      return notificationArrPromise.catch(reason => {
        console.log(reason);
        return [];
      });
    });
    const notificationArr: INotification[][] = await Promise.all(notifications);

    return _.flatten(notificationArr);
  }
}
